import { graphql } from '@/utils/graphql';

export const videoSelectorFragment = graphql(`
  fragment videoSelectorFields on videos {
    id
    provider
    identifier
    start_at
    type {
      translations(filter: { languages_code: { code: { _eq: $language } } }) {
        name
      }
    }
  }
`);
